import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
const FilterColumnSelector = (props) => {
    // Group the available columns by the relationship they are a part of. If they aren't part of a relationship, then they are
    // part of the base filter source, so we don't have a grouping for them.
    var _a, _b, _c, _d, _e, _f;
    // The grouping will be a Map where the key is the id of the relationship, and the value is a FiltersourceGrouping. Each
    // FilterSourceGrouping contains the relationship definition itself, as well as the columns that fall into that relationship.
    const columnsGrouped = props.filterSourceColumns.reduce((prev, cur, index, arr) => {
        const key = cur.filterSourceRelationship
            ? cur.filterSourceRelationship.id.toString()
            : "base";
        if (prev.has(key)) {
            const grouping = prev.get(key);
            if (grouping) {
                grouping.filterSourceColumns = [
                    ...grouping.filterSourceColumns,
                    cur.filterSourceColumn,
                ];
            }
            return prev;
        }
        prev.set(key, {
            filterSourceRelationship: cur.filterSourceRelationship,
            filterSourceColumns: [cur.filterSourceColumn],
        });
        return prev;
    }, new Map());
    const selectedColumn = props.filterSourceColumns.find(({ filterSourceColumn }) => (filterSourceColumn === null || filterSourceColumn === void 0 ? void 0 : filterSourceColumn.id) === (props === null || props === void 0 ? void 0 : props.selectedFilterSourceColumnId));
    function getOptionValue(filterSourceColumnId, filterSourceRelationshipId) {
        if (!filterSourceColumnId) {
            return "";
        }
        return `${filterSourceColumnId}::${filterSourceRelationshipId || ""}`;
    }
    return (_jsx("select", { className: "form-control", onChange: (event) => {
            if (!event.target.value) {
                // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
                props.onChange(null, null);
            }
            const split = event.target.value.split("::");
            const selectedColumnId = parseInt(split[0], 10);
            let selectedRelationshipId = null;
            if (split.length > 1) {
                selectedRelationshipId = parseInt(split[1], 10);
            }
            let selectedRelationship = null;
            const relationshipColumnGroup = columnsGrouped.get(split[1]);
            if (relationshipColumnGroup) {
                selectedRelationship =
                    relationshipColumnGroup.filterSourceRelationship;
            }
            props.onChange(selectedColumnId, selectedRelationshipId, selectedRelationship);
        }, value: getOptionValue(props.selectedFilterSourceColumnId, props.selectedFilterSourceRelationshipId), "aria-label": "Column source", children: !((_a = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.filterSourceColumn) === null || _a === void 0 ? void 0 : _a.deprecated) ? ( // If the selected column isn't deprecated, render options normally. Else, only render the deprecated option.
        _jsxs(_Fragment, { children: [_jsx("option", { value: "", children: "Choose a column" }), Array.from(columnsGrouped.keys()).flatMap((key) => {
                    const group = columnsGrouped.get(key);
                    if (!group) {
                        return "";
                    }
                    const columns = group.filterSourceColumns.filter((col) => (col === null || col === void 0 ? void 0 : col.deprecated) !== true);
                    if (key === "base") {
                        return columns.map((c) => {
                            var _a;
                            return (_jsx("option", { value: getOptionValue(c.id, null), children: c.displayName + " [" + ((_a = c.filterSource) === null || _a === void 0 ? void 0 : _a.displayName) + "]" }, c.id));
                        });
                    }
                    return (_jsx("optgroup", { label: group.filterSourceRelationship.title, children: columns.map((c) => {
                            var _a;
                            return (_jsx("option", { value: getOptionValue(c.id, group.filterSourceRelationship.id), children: c.displayName +
                                    " [" +
                                    ((_a = group === null || group === void 0 ? void 0 : group.filterSourceRelationship) === null || _a === void 0 ? void 0 : _a.title) +
                                    "]" }, c.id));
                        }) }, key));
                })] })) : (_jsx("option", { disabled: true, value: getOptionValue((_b = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.filterSourceColumn) === null || _b === void 0 ? void 0 : _b.id, (_c = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.filterSourceRelationship) === null || _c === void 0 ? void 0 : _c.id), children: ((_d = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.filterSourceColumn) === null || _d === void 0 ? void 0 : _d.displayName) +
                " [" +
                (
                // @ts-expect-error - TS2339 - Property 'filterSource' does not exist on type 'FilterSourceColumn'.
                (_f = (_e = selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.filterSourceColumn) === null || _e === void 0 ? void 0 : _e.filterSource) === null || _f === void 0 ? void 0 : _f.displayName) +
                "]" }, selectedColumn === null || selectedColumn === void 0 ? void 0 : selectedColumn.id)) }));
};
export default FilterColumnSelector;
